// key = 字符串名称
export const capabilityRegistry = {
    BATCH_UPDATE_STOCK: () => import('@/views/sell/product/pcnComponent/batch-update-stock.vue'),   // 批量改库存
    PRICE_UNIFIED: () => import('@/views/sell/product/pcnComponent/priceUnified.vue'),    // 批量改价
    SAN_KE_BOOKING: () => import('@/views/room-status/sanKeBooking/index-popupNotification.vue'),    // 散客预订
    LONG_BOOKING: () => import('@/views/room-status/longBooking-popupNotification/index.vue'),    // 长包房预订
    GROUP_BOOKING: () => import('@/views/room-status/groupBooking/index-popupNotification.vue'),    // 团队预订
    CHECK_IN: () => import('@/views/room-status/check-in/newIndex-popupNotification.vue'),    // 散客步入
    COMMON_BOOK: () => import('@/views/room-status/common-book/index.vue'),    // 新版统一预订
}
